const mappedSwots = {
  'efficiency': {
    'ORGANISAATIO': {
      'RAKENNE': '-LwTcWMl9ADFEkzz1O3l',
      'VALTA/VASTUU': '-LwTdq4pBMZytFYBgW0C',
      'YHTENÄISYYS': '-LwTe4DF0y64qm8ZVTGA',
    },
    'PROSESSIT': {
      'MÄÄRITYS JA KUVAUS': '-LwTeSkiZ_PlB5LVo8x3',
      'MITTARISTO': '-LwTeI-h0V6YWK5SuPG1',
      'TOIMINTAOHJEET': '-LwTe6JYg_DyafV_zE10',
    },
    'YHTEISTYÖ': {
      'TIIMIYTYMISEN VAIHE': '-LwTezeIfXsXKxC7PMfr',
      'YHTEISET TAVOITTEET': '-LwTeweWt0PCPxJIv4lF',
      'VUOROVAIKUUTUS TIIMIN SISÄLLÄ': '-LwTe_ssfnWe-QAyfZai',
    }
  },
  'capability': {
    'TYÖKYKY': {
      'YLEINEN TERVEYDENTILA': '-LwTfDS0aR1HRUOdrVAi',
      'SAIRAUSPOISSAOLOT': '-LwTfiXzTnSoSQPBzs38',
      'KOETTU STRESSI': '-LwTfybgmRGEsndcGaTH',
    },
    'OSAAMINEN': {
      'NYKYINEN OSAAMISTASO': '-LwTg4iStJ6Dh1OpJ7Fh',
      'OSAAMISTAVOITTEET': '-LwTgBSqxGbn5zjfieCl',
      'OSAAMISEN KEHITTÄMINEN': '-LwTgFkFOGPAjMxRpjub',
    },
    'MOTIVAATIO': {
      'TYÖTYYTYVÄISYYS': '-LwTgN020G5YjPg8cmkO',
      'MOTIVAATION MUOTO': '-LwTgS4WlCEjalLN0kx7',
      'OSAAMISEN KEHITTÄMISEN TUKI': '-LwTgXPjzip3S9Jxe1Hw',
    }
  }
}

export default {mappedSwots};
